import React from "react";
import PropTypes from "prop-types";

// Components
import PartnerImages from "../partner-images/PartnerImages";

// Styles
import styles from "./contact-us-chat-banner.module.scss";
import LiveChatButton from "../live-chat-button/LiveChatButton";

function ContactUsChatBanner({ channel, location }) {
  return (
    <div className={styles.chatBanner}>
      <div className={styles.leftSection}>
        <h3>LIVE CHAT WITH OUR PARTNERS</h3>
        <p>During temporary store closures, our in-store Partners are supporting our customer service team.</p>
        <div className={styles.buttonWrapper}>
          <LiveChatButton channel={channel} buttonLocation={location} />
        </div>
      </div>
      <div className={styles.imageWrapper}>
        <PartnerImages partners={3} partnersTablet={4} />
      </div>
    </div>
  );
}

ContactUsChatBanner.propTypes = {
  channel: PropTypes.string,
  location: PropTypes.string,
};

ContactUsChatBanner.defaultProps = {
  channel: null,
  location: null,
};

export default ContactUsChatBanner;
